<template>
  <div class="introduce">
    <p>暂无相关信息</p>
  </div>
</template>

<script>
export default {
  name: "9introduce",
};
</script>

<style scoped lang="scss">
@import "../scss/baseMain";
</style>
